/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/7/30
 * Time: 09:38
 * Desc: 云店设置-其他
 */

import { Component, Vue } from 'vue-property-decorator';
import Receipt from '@/views/components/receipt/receipt.vue'; // 开票说明配置
import VmCommissionLimit from '@/views/components/vmCommissionLimit/vmCommissionLimit.vue'; // 虚拟店长佣金阈值
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import sizeMapping from '@/views/components/sizeMapping/sizeMapping';
import embryFormOther from '@/views/components/embryFormOther';
import ProductBlackList from '@/views/components/productBlackList';
import { IPSService } from '@/services/ipsServices';
import baseAPIService from '@/services/base/baseAPIService.ts';
import { showPlatform } from '@/util';

@Component({
  components: {
    VmCommissionLimit,
    Receipt,
    sizeMapping,
    ProductBlackList,
    NoAuth,
    embryFormOther,
  },
})
export default class Extended extends Vue {
  /* 数据 */

  /**
   * 当前页面的索引
   * @type {string}
   */
  public curPage = '2';

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = true;

  public platformVersion = '';

  isShowTab = false

  /* 方法 */
  /**
   * 切换页面
   */
  public onPageSwitch(key): void {
    this.curPage = key;
    localStorage.setItem('curpage', key);
    console.log(this.curPage);
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getDomain();
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-BASIC-OTHERS');
    if (this.isContentBodyShow) {
      // 获取当前页索引
      this.curPage = localStorage.getItem('curpage') ? localStorage.getItem('curpage') : '2';
      const list = ['embryform', 'devtest2'];
      this.isShowTab = showPlatform(list)
    }
  }

  /**
   * 获取新老门户
   */
  public getDomain() {
      this.platformVersion = localStorage.getItem('platformVersion');
  }
}
